import { all, call, put, fork, takeEvery, select } from 'redux-saga/effects';
import {
    fetchProjectCostPrioritysSuccess,
    showProjectCostPriorityMessage,
    onSaveProjectCostPrioritySuccess,
    onDeleteProjectCostPrioritySuccess,
    addFavouriteProjectCostPrioritySuccess,
} from 'actions/projectCostPriority';
import {
    ON_SAVE_PROJECT_COST_PRIORITY,
    FETCH_ALL_PROJECT_COST_PRIORITY,
    ON_DELETE_PROJECT_COST_PRIORITY,
    ADD_FAVOURITE_PROJECT_COST_PRIORITY,
} from 'constants/ActionTypes';
import { fetchDataRequest, addOrUpdateDataRequest, updateDataRequest, deleteDataRequest  } from 'services/ApiService';
import { apiErrorMessageFormatter } from 'services/errorService';
import { ORGID_PATH_PARAM } from 'constants/api';

const currentOrg = (state) => state.orgs.selectedOrg;
const getProjectCostPriorityList = (state) => state.projectCostPrioritys.allProjectCostPriority;

export function* fetchProjectCostPrioritys() {
    try {
        const selectedOrg = yield select(currentOrg);
        const fetchedProjectCostPrioritys = yield call(
            fetchDataRequest,
            'projectCostPrioritys',
            [ORGID_PATH_PARAM],
            [selectedOrg ?.id]
        ) || [];
        yield put(fetchProjectCostPrioritysSuccess(fetchedProjectCostPrioritys));
    } catch (error) {
        yield put(showProjectCostPriorityMessage(apiErrorMessageFormatter(error)));
    }
}

export function* deleteProjectCostPriority({ payload }) {
    try {
        // payload should be the projectCostPriorityId
        const selectedOrg = yield select(currentOrg);
        yield call(
            deleteDataRequest,
            'deleteProjectCostPriority',
            'Deleting projectCostPriority '.concat(payload),
            [ORGID_PATH_PARAM, 'projectCostPriorityId'],
            [selectedOrg ?.id, payload]
        ) || [];
        yield put(onDeleteProjectCostPrioritySuccess(payload)); // just dispatch the id as the reducer will remove from the item from the list
    } catch (error) {
        yield put(showProjectCostPriorityMessage(apiErrorMessageFormatter(error)));
    }
}

export function* saveProjectCostPriority({ payload }) {
    try {
        const selectedOrg = yield select(currentOrg);
        const allProjectCostPrioritys = yield select(getProjectCostPriorityList);
        let finalPayload = { ...payload };
        // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is
        if (payload ?.orgid === '') {
            finalPayload = { ...payload, orgid: selectedOrg ?.id };
        }
        const savedProjectCostPriority = yield call(
            addOrUpdateDataRequest,
            allProjectCostPrioritys,
            finalPayload,
            'addProjectCostPriority',
            'updateProjectCostPriority',
            [ORGID_PATH_PARAM],
            [selectedOrg.id]);
        yield put(onSaveProjectCostPrioritySuccess(savedProjectCostPriority));
    } catch (error) {
        yield put(showProjectCostPriorityMessage(apiErrorMessageFormatter(error)));
    }
}

/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */
export function* addFavouriteProjectCostPriority({ payload }) {
    try {
        const allProjectCostPrioritys = yield select(getProjectCostPriorityList);
        const selectedOrg = yield select(currentOrg);
        const filtered = allProjectCostPrioritys.filter((entry) => entry ?.id === payload ?.id);

        if (filtered ?.length > 0) {
            const entry = filtered[0];
            const updatedProjectCostPriority = {
                ...entry,
                starred: !payload.starred
            };
            const auditMsg = 'Updating starred setting to '.concat(updatedProjectCostPriority ?.starred).concat(' for projectCostPriority ').concat(updatedProjectCostPriority ?.id);
            yield call(
                updateDataRequest,
                updatedProjectCostPriority,
                'updateProjectCostPriority',
                auditMsg,
                [ORGID_PATH_PARAM],
                [selectedOrg.id],
            );
            // now just pass on the original payload as the reducer will filter the list as per the state of the selection
            yield put(addFavouriteProjectCostPrioritySuccess(payload));
        }
    } catch (error) {
        yield put(showProjectCostPriorityMessage(error.messages));
    }
}

export function* fetchProjectCostPrioritysSaga() {
    yield takeEvery(FETCH_ALL_PROJECT_COST_PRIORITY, fetchProjectCostPrioritys);
}

export function* saveProjectCostPrioritySaga() {
    yield takeEvery(ON_SAVE_PROJECT_COST_PRIORITY, saveProjectCostPriority);
}

export function* deleteProjectCostPrioritySaga() {
    yield takeEvery(ON_DELETE_PROJECT_COST_PRIORITY, deleteProjectCostPriority);
}

export function* addFavouriteProjectCostPrioritySaga() {
    yield takeEvery(ADD_FAVOURITE_PROJECT_COST_PRIORITY, addFavouriteProjectCostPriority);
}

export default function* rootSaga() {
    yield all([
        fork(fetchProjectCostPrioritysSaga),
        fork(saveProjectCostPrioritySaga),
        fork(deleteProjectCostPrioritySaga),
        fork(addFavouriteProjectCostPrioritySaga),
    ]);
}


// WEBPACK FOOTER //
// ./sagas/projectCostPriority.js